import { RegisterToast } from '@core/Components/Toast/ToastDriver'

export const showErrorToast = (message: string, id: string) => {
  RegisterToast({
    id,
    message,
    type: 'error',
    timeout: 1.5,
    position: 'bottom',
  })
}
